export { default as MainPageLayout } from './MainPageLayout';
